import { HeaderSortCell } from '@/components/Filter'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { RateMarkupKey } from 'api/Exchange-Rates/RateMarkupDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const rateMarkupsColumns: GridColumn[] = [
  {
    title: 'Debit',
    show: true,
    field: 'debit',
    headerCell: HeaderSortCell,
    children: [
      {
        title: 'Wallet Type',
        field: RateMarkupKey.debitWalletType,
        headerCell: HeaderSortCell,
        cell: (props: GridCellProps): JSX.Element => {
          if (!props.dataItem?.debitWalletType?.name) {
            return <td />
          }
          return <td>{props.dataItem.debitWalletType.name}</td>
        },
        width: 180,
        resizable: true,
        filter: 'text',
        className: 'table-columns__content',
      },
      {
        title: 'Currency',
        field: RateMarkupKey.debitCurrency,
        headerCell: HeaderSortCell,
        cell: (props: GridCellProps): JSX.Element => {
          if (!props.dataItem?.debitCurrency?.id) {
            return <td />
          }
          return <td>{props.dataItem.debitCurrency.id}</td>
        },
        width: 180,
        resizable: true,
        filter: 'text',
        className: 'table-columns__content',
      },
    ],
  },
  {
    title: 'Credit',
    show: true,
    field: 'credit',
    headerCell: HeaderSortCell,
    children: [
      {
        title: 'Wallet Type',
        field: RateMarkupKey.creditWalletType,
        headerCell: HeaderSortCell,

        cell: (props: GridCellProps): JSX.Element => {
          if (!props.dataItem?.creditWalletType?.name) {
            return <td />
          }
          return <td>{props.dataItem.creditWalletType.name}</td>
        },
        width: 180,
        resizable: true,
        filter: 'text',
        className: 'table-columns__content',
      },
      {
        title: 'Currency',
        field: RateMarkupKey.creditCurrency,
        headerCell: HeaderSortCell,
        cell: (props: GridCellProps): JSX.Element => {
          if (!props.dataItem?.creditCurrency?.id) {
            return <td />
          }
          return <td>{props.dataItem.creditCurrency.id}</td>
        },
        width: 180,
        resizable: true,
        filter: 'text',
        className: 'table-columns__content',
      },
    ],
  },
  {
    title: 'Markup',
    field: RateMarkupKey.markup,
    cell: (props: GridCellProps): JSX.Element => {
      return <td className='table-columns__number'>{props.dataItem.markup || 0}</td>
    },
    resizable: true,
    filter: 'text',
    className: 'table-columns__number',
    show: true,
    headerCell: HeaderSortCell,
  },
  {
    title: 'Precision',
    field: RateMarkupKey.precision,
    cell: (props: GridCellProps): JSX.Element => {
      return <td className='table-columns__number'>{props.dataItem.precision || 0}</td>
    },
    resizable: true,
    filter: 'text',
    className: 'table-columns__number',
    show: true,
    headerCell: HeaderSortCell,
  },
]
